<template>
    <modal
        class="is-narrow"
        v-bind:title="__('Add campaign')"
        v-bind:is-open="isOpenAddModal"
        v-on:close-modal="close"
        v-bind:slot-props="errors"
    >
        <template v-slot:body>
            <div class="has-margin-b30">
                <control
                    label-field="name"
                    name="userAddControl"
                    type="autocomplete"
                    v-bind:label="__('User')"
                    v-bind:source-get="getUsers"
                    v-bind:source-search="getUsers"
                    v-model="campaign.userId"
                    value-field="id"
                />
                <div
                    class="has-text-danger has-margin-b10"
                    v-if="errors.user_id != null"
                >
                    {{ errors.user_id[0] }}
                </div>
            </div>
            <div class="has-margin-b30">
                <control
                    label-field="title"
                    name="programAddControl"
                    type="autocomplete"
                    v-bind:label="__('Program')"
                    v-bind:source-get="getPrograms"
                    v-bind:source-search="getPrograms"
                    v-model="campaign.programId"
                    value-field="id"
                />
                <div
                    class="has-text-danger has-margin-b10"
                    v-if="errors.program_id != null"
                >
                    {{ errors.program_id[0] }}
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <btn
                class="is-block is-success"
                type="default"
                v-html="__('Save')"
                v-on:click="createdCampaign"
            ></btn>
        </template>
    </modal>
</template>

<script>
import ProgramRepository from '../../../repositories/ProgramRepository';
import userConfig from '../../../config/userConfig';
import UserRepository from '../../../repositories/UserRepository';
import { Btn, Control, Modal } from '@teamfurther/cinderblock';

export default {
    components: {
        Btn,
        Control,
        Modal
    },
    data: function() {
        return {
            campaign: {
                programId: null,
                userId: null
            },
            programRepository: new ProgramRepository(),
            userRepository: new UserRepository()
        };
    },
    methods: {
        createdCampaign: function() {
            this.$emit('create', this.campaign);
        },
        close: function() {
            this.$emit('close');
        },
        getPrograms: async function(searchString) {
            try {
                return await this.programRepository.getProgramsFilteredByTitle(
                    searchString
                );
            } catch (e) {}

            return [];
        },
        getUsers: async function(searchString) {
            try {
                return await this.userRepository.getUsersFilteredByNameAndRole(
                    searchString,
                    userConfig.roles.user
                );
            } catch (e) {}

            return [];
        }
    },
    props: {
        errors: {
            required: true,
            type: Object
        },
        isOpenAddModal: {
            required: true,
            type: Boolean
        }
    }
};
</script>
